import { render } from "./gglb.vue?vue&type=template&id=5e2cff8c&scoped=true&ts=true"
import script from "./gglb.vue?vue&type=script&lang=ts"
export * from "./gglb.vue?vue&type=script&lang=ts"

import "./gglb.vue?vue&type=style&index=0&id=5e2cff8c&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2cff8c"]])

export default __exports__